import ApiService from '@/services/core/api.service'

const HistoryService = {
  async get (query = '') {
    return ApiService.get(`disbursement-head/reports/payment-vouchers?${query}`)
  },

  async post (payload) {
    return ApiService.post('disbursement-head/reports/payment-vouchers', payload)
  },

  async put (payload) {
    return ApiService.put(`disbursement-head/reports/payment-vouchers/${payload.id}`, payload)
  },

  async delete (payload) {
    return ApiService.delete(`disbursement-head/reports/payment-vouchers/${payload.id}`)
  }
}

export default HistoryService
